import { DEFAULT_EMPTY_CELL_VALUE } from "./config";
import { InvalidValueError } from "./errors";
import { YieldTypes } from "./globalValues";

export function validateISIN(isin: string | null) {
  if (isin == null || isin == "") {
    throw new InvalidValueError("ISIN Value Error", "Data for security does not have ISIN");
  }
}

export function validateName(name: string | null) {
  if (name == null || name == "") {
    throw new InvalidValueError("Name Value Error", "Data for security does not have Name");
  }
}

export function validateAlias(alias: string | null) {
  if (alias == null || alias == "") {
    throw new InvalidValueError("Alias Value Error", "Data for security does not have Alias");
  }
}

export function validateYieldValue(yieldValue: string | null | number) {
  if (yieldValue === null || yieldValue === "" || yieldValue === DEFAULT_EMPTY_CELL_VALUE) {
    throw new InvalidValueError("Yield Value Error", "Yield value is empty");
  }
  if (Number(yieldValue) <= 0) {
    throw new InvalidValueError("Yield Value Error", "Yield value is less or equal than zero");
  }

  if (Number.isNaN(Number(yieldValue))) {
    throw new InvalidValueError("Yield Value Error", "Yield value is not a number");
  }
}

export function validateYieldType(yieldType: string | null) {
  if (yieldType == null || yieldType == "" || !YieldTypes.includes(yieldType)) {
    throw new InvalidValueError("Yield Type Error", "Data for security does not have a valid Yield Type");
  }
}
export function validateQuoteFeed(quoteFeeder: string | null) {
  if (quoteFeeder == null || quoteFeeder == "") {
    throw new InvalidValueError("Quote Feeder Error", "Data for security does not have a valid Quote Feeder");
  }
}
